import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useRoutes() {
  const navigate = useNavigate();

  const goToEditUnits = useCallback(
    (surveyId: string, unitId?: number | undefined) => {
      navigate({
        pathname: "/site/survey/unit/edit",
        search: `?id=${surveyId}&unitId=${unitId || ""}`,
      });
    },
    [navigate]
  );

  const goToSurvey = useCallback(
    (surveyId?: string) => {
      console.log("goToSurvey");
      navigate({
        pathname: "/site/survey/edit",
        search: `?id=${surveyId || ""}`,
      });
    },
    [navigate]
  );

  const goToSurveyList = useCallback(() => {
    navigate({
      pathname: "/site/survey/list",
    });
  }, [navigate]);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return { goToEditUnits, goBack, goToSurvey, goToSurveyList };
}
